import { useEffect, useRef, useState } from 'react';
import { useLink } from 'react-router-stack';
import useGame from '../../../utilities/hooks/game';

import EventEmitter from '../../../utilities/EventEmitter';
import { hideLoader } from '../../../actions/app-actions-types';
import { getContestFilteredList, getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';

import { useDispatch, useSelector } from 'react-redux';
import constants from '../../../constants';
import AllContestListMWeb from './index_mWeb';
import React from 'react';
import AllContestListWeb from './index_web';

const AllContestList = () => {
  const navigate = useLink();
  const dispatch = useDispatch();
  const {
    gameType,
    contestCategories = {},
    contestFilter: contestFilterList = [],
    item: matchItem,
    fantasyMatchClick,

    contestTypes = {},
    myTeamList = []
  } = useGame();

  const {
    status: matchStatus = '',
    gameState = 0,
    defaultSort = '',
    categoryId = '',
    matchDelayed = false,
    isAppliedFilter = false
  } = matchItem;

  const isAppliedFilterRef = useRef(isAppliedFilter);

  const totalTeamsCount = myTeamList.length;

  const [error, setError] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [allContestList, setAllContestList] = useState([] as any);
  const [totalChallenges, setTotalChallenges] = useState(0);
  const [contestFilterVisible, setContestFilterVisible] = useState(false);
  const [contestShare, setContestShare] = useState(false);
  const [contestLink] = useState('');
  const [contestTitle] = useState('');
  const { allContestList: fantasyCricketAllContestList } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { allContestList: fantasyFootballAllContestList } = useSelector(
    (state: any) => state.fantasy_football
  );
  let contestCategory = {
    title: 'All Contest',
    description: `${totalChallenges} Contest Available`
  };
  if (categoryId) {
    contestCategory = contestCategories[categoryId];
  }

  useEffect(() => {
    getAllContestListAPI();
    EventEmitter.on('updateContestsList', getAllContestListAPI);
    return () => {
      EventEmitter.off('updateContestsList', getAllContestListAPI);
    };
  }, [fantasyCricketAllContestList, fantasyFootballAllContestList]);
  const getAllContestListAPI = () => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = [...fantasyCricketAllContestList];
    } else if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = [...fantasyFootballAllContestList];
    }
    dispatch(hideLoader());
    if (!error) {
      try {
        getSortAndFilterData(result, isAppliedFilterRef.current);
        setError(false);
      } catch (error) {
        setError(false);
      }
    } else {
      setError(true);
    }
  };

  const getSortAndFilterData = async (result: any[], isAppliedFilter: any) => {
    let newList = result;
    if (isAppliedFilter) {
      newList = await getContestFilteredList(result, contestFilterList, contestTypes);
    }
    switch (defaultSort) {
      case 'Entry':
        newList.sort((a: { entryFee: number }, b: { entryFee: number }) => b.entryFee - a.entryFee);
        break;
      case 'PrizePool':
        newList.sort(
          (a: { maximumPlayers: number }, b: { maximumPlayers: number }) =>
            b.maximumPlayers - a.maximumPlayers
        );
        break;
      case 'Spots':
        newList.sort(
          (a: { maximumPlayers: number }, b: { maximumPlayers: number }) =>
            b.maximumPlayers - a.maximumPlayers
        );
        break;
      case 'Winner':
        newList.sort(
          (a: { winningsAmount: number }, b: { winningsAmount: number }) =>
            b.winningsAmount - a.winningsAmount
        );
        break;
      default:
        newList.sort((a: { entryFee: number }, b: { entryFee: number }) => b.entryFee - a.entryFee);
    }
    setTotalChallenges(newList.length);
    setAllContestList(newList);
  };

  const onPressCard = (contest: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest,
          totalTeamsCount
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const onUpdateChallenge = (allContestList: any) => {
    const allContestList_ = [...allContestList];
    setAllContestList(allContestList_);
    setForceRefresh(!forceRefresh);
  };

  const onPressShare = async () => {};

  const onApplyFilter = () => {
    isAppliedFilterRef.current = true;
    setContestFilterVisible(false);
    getAllContestListAPI();
  };

  const onClearFilter = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          categoryId: '',
          title: 'All Contest',
          defaultSort: ''
        }
      })
    );
    isAppliedFilterRef.current = false;
    setContestFilterVisible(false);
    getAllContestListAPI();
  };

  const onPressFilterDismiss = () => {
    setContestFilterVisible(false);
  };

  const onPressFilter = () => {
    setContestFilterVisible(true);
  };

  const onPressShareModalDismiss = () => {
    setContestShare(false);
  };
  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <AllContestListMWeb
          allContestList={allContestList}
          onUpdateChallenge={onUpdateChallenge}
          defaultSort={defaultSort}
          onPressFilter={onPressFilter}
          contestCategory={contestCategory}
          totalChallenges={totalChallenges}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          matchStatus={matchStatus}
          gameState={gameState}
          totalTeamsCount={totalTeamsCount}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
        />
      ) : (
        <AllContestListWeb
          allContestList={allContestList}
          onUpdateChallenge={onUpdateChallenge}
          defaultSort={defaultSort}
          onPressFilter={onPressFilter}
          contestCategory={contestCategory}
          totalChallenges={totalChallenges}
          onPressCard={onPressCard}
          onPressShare={onPressShare}
          matchStatus={matchStatus}
          gameState={gameState}
          totalTeamsCount={totalTeamsCount}
          matchItem={matchItem}
          matchDelayed={matchDelayed}
          gameType={gameType}
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          contestFilterVisible={contestFilterVisible}
          onPressFilterDismiss={onPressFilterDismiss}
          contestLink={contestLink}
          contestTitle={contestTitle}
          contestShare={contestShare}
          onPressShareModalDismiss={onPressShareModalDismiss}
          onCalledDeadline={onCalledDeadline}
        />
      )}
    </React.Fragment>
  );
};
export default AllContestList;
